import { useEffect } from 'react';
import { setZendeskWidgetVisible } from '@/components/atoms/zendesk-widget/set-visibility';

// EWM-630 — Hide the Zendesk chat launcher while `hidden` is true, restoring it
// when `hidden` goes back to false or the caller unmounts.
//
// The Windcave card modal renders as a full-width bottom sheet on mobile, which
// puts the PAY button exactly where the floating chat bubble sits (the widget's
// z-index is above the modal overlay). Rather than fight the third-party iframe's
// z-index with brittle CSS selectors, we drive Zendesk's own messenger API for
// the duration of the modal's lifecycle.
//
// No-op when `hidden` is false, so the widget behaves normally on every other
// surface and whenever the modal is closed.
const useHideZendeskWidget = (hidden: boolean): void => {
  useEffect(() => {
    if (!hidden) return;
    setZendeskWidgetVisible(false);
    return () => setZendeskWidgetVisible(true);
  }, [hidden]);
};

export default useHideZendeskWidget;
